import React from 'react';
import P from 'prop-types';

function ErrorDisplay({ children = 'ERROR!' }) {
  return (
    <div>
      {children}
    </div>
  );
}

ErrorDisplay.propTypes = {
  children: P.any.isRequired,
};

ErrorDisplay.defaultProps = {
};

export default ErrorDisplay;
